var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"analyzer"},[_c('canvas',{ref:"scope"})])
}
var staticRenderFns = []

export { render, staticRenderFns }